import { render, staticRenderFns } from "./icono_chat.vue?vue&type=template&id=4c2ec797&scoped=true&"
import script from "./icono_chat.vue?vue&type=script&lang=ts&"
export * from "./icono_chat.vue?vue&type=script&lang=ts&"
import style0 from "./icono_chat.vue?vue&type=style&index=0&id=4c2ec797&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2ec797",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBadge,VBtn})
